import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';
import LvmSalesWidgetComponent from './components/lvm-sales-widget/lvm-sales-widget-component';
import LvmSalesGameListComponent from './components/lvm-sales-game-list/lvm-sales-game-list-component';
import LvmSalesHistoryComponent from './components/lvm-sales-history/lvm-sales-history-component';

export default angular
  .module('lvm-sales-widget', [])
  .component('lvmSalesWidget', new LvmSalesWidgetComponent())
  .component('lvmSalesGameList', new LvmSalesGameListComponent())
  .component('lvmSalesHistory', new LvmSalesHistoryComponent())
  .config([
    '$stateProvider',
    function configuration($stateProvider) {
      $stateProvider.state('lvmSales-details', {
        parent: 'arw',
        url: '/lvm-sales/history/:retailerNo?',
        template: `
                  <lvm-sales-history>
                  </lvm-sales-history>`,
        redirectTo: 'permissions-denied',
        params: {
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('LVM Sales History')));
            },
          ],
        },
      });
    },
  ]);



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/lvm-sales/lvm-sales-module.js